module.exports = __webpack_public_path__ + "media/images/pagar-a5c4f95cebde18bd0498f8d9ab8643d3.svg";